export default "/images/vendor/flag-icons/flags/1x1/lk.svg?ab7b92bda5c7b8891f1bbe45f54811ec";